package or.garden.manager.components

import androidx.compose.runtime.*
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.dom.*

data class SnackbarMessage(
    val message: String,
    val type: SnackbarType = SnackbarType.INFO,
    val duration: Long = 3000
)

enum class SnackbarType {
    SUCCESS, ERROR, INFO, WARNING
}

@Composable
fun SnackbarHost(message: SnackbarMessage?, onDismiss: () -> Unit) {
    if (message == null) {
        // Dodajemo prazan Div sa z-indexom čak i kad nema poruke da osiguramo sloj
        Div({
            style {
                property("position", "fixed")
                property("z-index", "9999")
                property("pointer-events", "none")
            }
        }) {}
        return
    }

    LaunchedEffect(message) {
        delay(message.duration)
        onDismiss()
    }

    Div({
        attr("id", "snackbar-container")
        style {
            property("position", "fixed")
            property("bottom", "2rem")
            property("left", "50%")
            property("transform", "translateX(-50%)")
            property("z-index", "10000")
            property("pointer-events", "none")
            property("display", "flex")
            property("justify-content", "center")
            property("width", "100%")
        }
    }) {
        Div({
            val bgColor = when (message.type) {
                SnackbarType.SUCCESS -> "#10b981" // emerald-600
                SnackbarType.ERROR -> "#dc2626"   // red-600
                SnackbarType.WARNING -> "#f59e0b" // amber-500
                SnackbarType.INFO -> "#1f2937"    // gray-800
            }
            style {
                property("background-color", bgColor)
                property("color", "white")
                property("padding", "0.75rem 1.5rem")
                property("border-radius", "1rem")
                property("box-shadow", "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)")
                property("display", "flex")
                property("align-items", "center")
                property("gap", "0.75rem")
                property("min-width", "300px")
                property("pointer-events", "auto")
                property("animation", "snackbar-in 0.3s ease-out")
            }
        }) {
            val icon = when (message.type) {
                SnackbarType.SUCCESS -> "fa-check-circle"
                SnackbarType.ERROR -> "fa-exclamation-circle"
                SnackbarType.WARNING -> "fa-exclamation-triangle"
                SnackbarType.INFO -> "fa-info-circle"
            }
            I({ classes("fas", icon) })
            Span({
                style {
                    property("flex", "1")
                    property("font-weight", "500")
                }
            }) {
                Text(message.message)
            }
            Button({
                style {
                    property("background", "none")
                    property("border", "none")
                    property("color", "white")
                    property("cursor", "pointer")
                    property("opacity", "0.8")
                    property("padding", "0.25rem")
                }
                onClick { onDismiss() }
            }) {
                I({ classes("fas", "fa-times") })
            }
        }
    }
}
